import { useState, useEffect } from 'react';

function getStorageValue(key, defaultValue) {
  // getting stored value. This won't work when running react_component from rails
  const saved = typeof window !== 'undefined' && localStorage.getItem(key);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      return saved;
    }
  } else if (defaultValue) {
    if (typeof window !== 'undefined') localStorage.setItem(key, JSON.stringify(defaultValue));
    return defaultValue;
  }
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    if (value !== undefined && typeof window !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  return [value, setValue];
};
